/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author paulirish / http://paulirish.com/
 */

import {
	MathUtils,
	Spherical,
	Vector3,
	Vector2,
	TOUCH,
} from "../../../build/three.module.js";

var FirstPersonControlsTouch = function ( object, domElement ) {

	if ( domElement === undefined ) {

		console.warn( 'THREE.FirstPersonControls: The second parameter "domElement" is now mandatory.' );
		domElement = document;

	}

	this.object = object;
	this.domElement = domElement;
    console.log("---------- TOUCH CAMERA ----------")
	// API

	this.enabled = true;
    this.hasTouch = false;
	this.movementSpeed = 1.0;
	this.lookSpeed = 1;//0.005;
	this.followMouse =true;
	this.touchForward = true;
	this.lookVertical = true;
	this.autoForward = false;

	this.activeLook = true;
	

	this.heightSpeed = false;
	this.heightCoef = 1.0;
	this.heightMin = 0.0;
	this.heightMax = 1.0;

	this.constrainVertical = false;
	this.verticalMin = 0;
	this.verticalMax = Math.PI;

	this.mouseDragOn = false;

	// internals

	this.autoSpeedFactor = 0.0;

	this.mouseX = 0;
	this.mouseY = 0;

	this.moveForward = false;
	this.moveBackward = false;
	this.moveLeft = false;
	this.moveRight = false;

	this.viewHalfX = 0;
	this.viewHalfY = 0;

	this.rotateStart = new Vector2();
	this.rotateEnd = new Vector2();
	this.rotateDelta = new Vector2();
	this.rotateSpeed =1;
	// private variables

	var lat = 0;
	var lon = 0;
 
	var lookDirection = new Vector3();
	var spherical = new Spherical();
	var target = new Vector3();
	var sphericalDelta = new Spherical();
	//

	if ( this.domElement !== document ) {

		this.domElement.setAttribute( 'tabindex', - 1 );

	}

	//

	this.handleResize = function () {

		if ( this.domElement === document ) {

			this.viewHalfX = window.innerWidth / 2;
			this.viewHalfY = window.innerHeight / 2;

		} else {

			this.viewHalfX = this.domElement.offsetWidth / 2;
			this.viewHalfY = this.domElement.offsetHeight / 2;

		}

	};

	this.onMouseDown = function ( event ) {

		if ( this.domElement !== document ) {

			this.domElement.focus();

		}

		event.preventDefault();
		event.stopPropagation();

		if ( this.activeLook ) {

			switch ( event.button ) {

				case 0: this.moveForward = true; break;
				case 2: this.moveBackward = true; break;

			}

		}

		this.mouseDragOn = true;

	};
    this.onTouchStart = function ( event ) {

		if ( this.domElement !== document ) {

			this.domElement.focus();

		}

		event.preventDefault();
		event.stopPropagation();

		if ( this.activeLook ) {
			if(event.touches.length==2){
				this.touchForward=!this.touchForward;
			}
			if(event.touches.length==3){
				this.moveBackward = true;
			}
			if (this.touchForward){
			 	this.moveForward = true;
			}
		

		}

		this.mouseDragOn = true;
		this.followMouse=true;
		
		this.handleTouchStartRotate(event)

	};
	this.onMouseUp = function ( event ) {

		event.preventDefault();
		event.stopPropagation();

		if ( this.activeLook ) {

			switch ( event.button ) {

				case 0: this.moveForward = false; break;
				case 2: this.moveBackward = false; break;

			}

		}

		this.mouseDragOn = false;

	};
    this.onTouchEnd = function ( event ) {
		//event.preventDefault();
		//event.stopPropagation();
		this.moveForward = false; 
		this.moveBackward = false; 
		this.moveLeft = false;
		this.moveRight = false;
		this.mouseDragOn = false;
		console.log("TOUCH END")
		this.followMouse=false;

	};
    this.onTouchMove =  function ( event ) {
        //console.log("TOUCH ",event)
		if(event.touches.length==1){
			if ( this.domElement === document ) {
				this.mouseX = event.touches[0].pageX - this.viewHalfX;
				this.mouseY = event.touches[0].pageY - this.viewHalfY;
			} else {
				this.mouseX = event.touches[0].pageX - this.domElement.offsetLeft - this.viewHalfX;
				this.mouseY = event.touches[0],pageY - this.domElement.offsetTop - this.viewHalfY;
			}
		this.handleTouchMoveRotate(event)
		}
		
	};
	this.onMouseMove = function ( event ) {

		if ( this.domElement === document ) {

			this.mouseX = event.pageX - this.viewHalfX;
			this.mouseY = event.pageY - this.viewHalfY;

		} else {

			this.mouseX = event.pageX - this.domElement.offsetLeft - this.viewHalfX;
			this.mouseY = event.pageY - this.domElement.offsetTop - this.viewHalfY;

		}
		

	};
	this.handleTouchStartRotate = function ( event ) {

		if ( event.touches.length == 1 ) {

			this.rotateStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

		} else {

			var x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
			var y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

			this.rotateStart.set( x, y );

		}
		console.log("ROTATE",this.rotateStart)

	}
	this.handleTouchMoveRotate= function( event ) {

		if ( event.touches.length == 1 ) {

			this.rotateEnd.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

		} else {

			var x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
			var y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

			this.rotateEnd.set( x, y );

		}
		console.log(this.rotateEnd, this.rotateStart,this.rotateSpeed)
		this.rotateDelta.subVectors( this.rotateEnd, this.rotateStart ).multiplyScalar( this.rotateSpeed );

		
		this.rotateLeft( 2 * Math.PI * this.rotateDelta.x / window.innerHeight ); // yes, height

		this.rotateUp( 2 * Math.PI * this.rotateDelta.y / window.innerHeight );

		this.rotateStart.copy( this.rotateEnd );

	}
	this.onKeyDown = function ( event ) {

		//event.preventDefault();

		switch ( event.keyCode ) {

			case 38: /*up*/
			case 87: /*W*/ this.moveForward = true; break;

			case 37: /*left*/
			case 65: /*A*/ this.moveLeft = true; break;

			case 40: /*down*/
			case 83: /*S*/ this.moveBackward = true; break;

			case 39: /*right*/
			case 68: /*D*/ this.moveRight = true; break;

			case 82: /*R*/ this.moveUp = true; break;
			case 70: /*F*/ this.moveDown = true; break;

		}

	};

	this.onKeyUp = function ( event ) {

		switch ( event.keyCode ) {

			case 38: /*up*/
			case 87: /*W*/ this.moveForward = false; break;

			case 37: /*left*/
			case 65: /*A*/ this.moveLeft = false; break;

			case 40: /*down*/
			case 83: /*S*/ this.moveBackward = false; break;

			case 39: /*right*/
			case 68: /*D*/ this.moveRight = false; break;

			case 82: /*R*/ this.moveUp = false; break;
			case 70: /*F*/ this.moveDown = false; break;

		}

	};

	this.lookAt = function ( x, y, z ) {

		if ( x.isVector3 ) {

			target.copy( x );

		} else {

			target.set( x, y, z );

		}

		this.object.lookAt( target );

		setOrientation( this );

		return this;

	};
	this.rotateLeft = function( angle ) {
		console.log("LEFT",angle)
		sphericalDelta.theta -= angle;

	}

	this.rotateUp = function( angle ) {

		sphericalDelta.phi -= angle;

	}
	this.update = function () {

		var targetPosition = new Vector3();

		return function update( delta ) {
			if (this.followMouse){
			if ( this.enabled === false ) return;

			if ( this.heightSpeed ) {

				var y = MathUtils.clamp( this.object.position.y, this.heightMin, this.heightMax );
				var heightDelta = y - this.heightMin;

				this.autoSpeedFactor = delta * ( heightDelta * this.heightCoef );

			} else {

				this.autoSpeedFactor = 0.0;

			}

			var actualMoveSpeed = delta * this.movementSpeed;

			if ( this.moveForward || ( this.autoForward && ! this.moveBackward ) ) this.object.translateZ( - ( actualMoveSpeed + this.autoSpeedFactor ) );
			if ( this.moveBackward ) this.object.translateZ( actualMoveSpeed );

			if ( this.moveLeft ) this.object.translateX( - actualMoveSpeed );
			if ( this.moveRight ) this.object.translateX( actualMoveSpeed );

			if ( this.moveUp ) this.object.translateY( actualMoveSpeed );
			if ( this.moveDown ) this.object.translateY( - actualMoveSpeed );

			var actualLookSpeed = delta * this.lookSpeed;

			if ( ! this.activeLook ) {

				actualLookSpeed = 0;

			}

			var verticalLookRatio = 1;

			if ( this.constrainVertical ) {

				verticalLookRatio = Math.PI / ( this.verticalMax - this.verticalMin );

			}

			lon -= this.mouseX * actualLookSpeed;
			if ( this.lookVertical ) lat -= this.mouseY * actualLookSpeed * verticalLookRatio;

			lat = Math.max( - 85, Math.min( 85, lat ) );

			var phi = MathUtils.degToRad( 90 - lat );
			var theta = MathUtils.degToRad( lon );

			if ( this.constrainVertical ) {

				phi = MathUtils.mapLinear( phi, 0, Math.PI, this.verticalMin, this.verticalMax );

			}

			var position = this.object.position;
			console.log()
			//spherical.theta += sphericalDelta.theta;
			//spherical.phi += sphericalDelta.phi;
			
				targetPosition.setFromSphericalCoords( 1, phi, theta ).add( position );
				this.object.lookAt( targetPosition );
				//let tp=new Vector3(this.mouseX,position.y,position.z)
				//this.object.lookAt(tp)
				//this.lookAt( targetPosition );
			}

		};

	}();

	function contextmenu( event ) {

		event.preventDefault();

	}

	this.dispose = function () {

		this.domElement.removeEventListener( 'contextmenu', contextmenu, false );
		this.domElement.removeEventListener( 'mousedown', _onMouseDown, false );
		this.domElement.removeEventListener( 'mousemove', _onMouseMove, false );
        this.domElement.removeEventListener( 'touchmove', _onTouchMove, false );
        this.domElement.removeEventListener( 'touchstart', _onTouchStart, false );
        this.domElement.removeEventListener( 'touchend', _onTouchEnd, false );
		this.domElement.removeEventListener( 'mouseup', _onMouseUp, false );

		window.removeEventListener( 'keydown', _onKeyDown, false );
		window.removeEventListener( 'keyup', _onKeyUp, false );

	};

	var _onMouseMove = bind( this, this.onMouseMove );
    var _onTouchMove = bind( this, this.onTouchMove );
    var _onTouchStart = bind( this, this.onTouchStart );
    var _onTouchEnd = bind( this, this.onTouchEnd );
	var _onMouseDown = bind( this, this.onMouseDown );
	var _onMouseUp = bind( this, this.onMouseUp );
	var _onKeyDown = bind( this, this.onKeyDown );
	var _onKeyUp = bind( this, this.onKeyUp );

	this.domElement.addEventListener( 'contextmenu', contextmenu, false );
	this.domElement.addEventListener( 'mousemove', _onMouseMove, false );
    this.domElement.addEventListener( 'touchmove', _onTouchMove, false );
    this.domElement.addEventListener( 'touchstart', _onTouchStart, false );
    this.domElement.addEventListener( 'touchend', _onTouchEnd, false );
	this.domElement.addEventListener( 'mousedown', _onMouseDown, false );
	this.domElement.addEventListener( 'mouseup', _onMouseUp, false );

	window.addEventListener( 'keydown', _onKeyDown, false );
	window.addEventListener( 'keyup', _onKeyUp, false );

	function bind( scope, fn ) {

		return function () {

			fn.apply( scope, arguments );

		};

	}

	function setOrientation( controls ) {

		var quaternion = controls.object.quaternion;

		lookDirection.set( 0, 0, - 1 ).applyQuaternion( quaternion );
		spherical.setFromVector3( lookDirection );
		spherical.theta += sphericalDelta.theta;
		spherical.phi += sphericalDelta.phi;
console.log("SPD-t",sphericalDelta.theta)
		lat = 90 - MathUtils.radToDeg( spherical.phi );
		lon = MathUtils.radToDeg( spherical.theta );

	}

	this.handleResize();

	setOrientation( this );

};

export { FirstPersonControlsTouch };
